export default {
  'zh-CN': {
    pleaseChoose: '请选择',
    search: '搜索'
  },
  en: {
    pleaseChoose: 'Please select',
    search: '搜索_en'
  }
}
